document.addEventListener("DOMContentLoaded", function() {
  
    const $sample_atc_submit_event = async function ($form_data) {
      const $sample_addtocart_result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify($form_data),
      });

      const $atc_success_result = await $sample_addtocart_result.json();
      if ($atc_success_result.items) {
        if (
          document.querySelector("cart-drawer") &&
          document.querySelector("cart-drawer").classList.contains("is-empty")
        )
          document.querySelector("cart-drawer").classList.remove("is-empty");
        const quickAddModal = document.querySelector("quick-add-modal");

        if (quickAddModal) {
          document.body.addEventListener(
            "modalClosed",
            () => {
              setTimeout(() => {
                document
                  .querySelector("cart-drawer")
                  .renderContents($atc_success_result);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          document
            .querySelector("cart-drawer")
            .renderContents($atc_success_result);
        }
        // flash("Product added!");
        // window.location.href = '/checkout';
        // SlideCart.open();
        // load_cart();
      } else {
        console.error($atc_success_result);
      }
    };

    $(document).on("change", ".subscription-plan__variant-options input[type=radio][name^=Color-]", function(e) {
      let $match = $(`variant-radios .product-form__input input[value="${$(this).val()}"]`);
      $match.prop('checked', true);
      $match[0].dispatchEvent(new Event('change', { bubbles: true }));
    });

    $(document).on("click", ".trigger_btn", function (e) {
      e.preventDefault(), e.stopImmediatePropagation();
      let selectedColor
      let sample_product_atc_array
      let vals
      let mainProp
      let subText

        // BREAKPOINT HERE TO REACH THE CHECKED INPUT FOR DATA
        selectedColor = $('.Livia_product_color_selector_cell.active').attr('data-title-full')
        sample_product_atc_array = [];
        
        var mode = $('.Livia_delivery_mode_switch.active').attr('data');
        if( mode == 'autodelivery'){
          subText = $('.Livia_main_product_atc').attr('data-subText-sub');
          vals = $('.Livia_product_color_selector_cell.active').attr('data-id');
        }
        else if (mode == 'onetime'){
          subText = $('.Livia_main_product_atc').attr('data-subText-onetime');
          vals = $('.Livia_product_color_selector_cell.active').attr('data-id');
        }
        else if (mode == 'bundle'){
          subText = $('.Livia_main_product_atc').attr('data-subText-onetime');
          vals = $('.Livia_product_color_selector_cell.active').find('.Livia_product_bundle__id').attr('data-id');
        }

        mainProp = $('.Livia_product_color_selector_cell').attr('data-title');

      let specialGift_Id = $('.special-gift-product').attr('data-giftId');

      // console.log(specialGift_Id, 'SPECIAL GIFT ID');
      var sellingPlanId = $('.Livia_main_product_atc').attr('data-selling-plan-id');
      var subscriptionPlanId = $('.Livia_main_product_atc').attr('data-value');

      let randomNumber = Math.random().toString().replace('0.','')

      if (mode == 'autodelivery' ) {
        sample_product_atc_array.push({
          id: String(subscriptionPlanId),
          quantity: 1,
          properties: {
            _Product_Plan: mainProp,
            _subscription: subText,
            _subscription_plan: subText,
            _product_design: pageType,
            _matching_line: randomNumber
          },
          selling_plan: String(sellingPlanId),
        });
        sample_product_atc_array.push({
          id: vals,
          quantity: 1,
          properties: {
            _Product_Plan: mainProp,
            _subscription_plan: subText,
            _matching_line: randomNumber
          },
        });
      } else {
        sample_product_atc_array.push({
          id: vals,
          quantity: 1,
          properties: {
            _Product_Plan: mainProp,
            _subscription_plan: subText,
            _matching_line: randomNumber
          },
        });
      }
      

      // if (specialGift_Id) {
      //   sample_product_atc_array.push({
      //     id: specialGift_Id,
      //     quantity: 1,
      //     properties: {
      //       _Product_Plan: mainProp,
      //       _subscription_plan: subText,
      //       _matching_line: randomNumber
      //     },
      //   });
      // }

      let sample_product_atc_formData = {
        items: sample_product_atc_array,
        sections_url: window.location.pathname,
        sections: document
          .querySelector("cart-drawer")
          .getSectionsToRender()
          .map((section) => section.id),
      };

      $sample_atc_submit_event(sample_product_atc_formData);
    });

    $(document).on("click", ".cart_drawer_remove_btn", function (e) {
      e.preventDefault(), e.stopImmediatePropagation();
      let dataName = $(this).parents(".cart-item").data("remove");
      var data = { updates: {} };
      if (dataName == "") {
        let allData = $(this).parents(".cart-item").data("key");
        data.updates[allData] = 0;
      } else {
        let allData = $(`.cart-item[data-remove = ${dataName}]`);
        allData.each(function (index, elem) {
          let vals = $(this).data("key");
          data.updates[vals] = 0;
        });
      }
      jQuery.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: data,
        dataType: "json",
        success: function (cart) {
          $.getJSON("/cart.js", function (cart) {
            $(".cart-count-bubble span[aria-hidden='true']").text(
              cart.item_count
            );
            if (cart.item_count <= 0) {
              $("cart-drawer").addClass("is-empty");
            } else {
              $("cart-drawer").removeClass("is-empty");
            }
          });
          flash("Product deleted!");
          load_cart();
        },
      });
    });
  });
